<template>
    <div style="margin-top:20px;" class="top-line">
        <div class="info-wrap">
		<table cellspacing="1" width="100%" class="order-info">
            <tr>
                <td align="right">定单编码：</td>
                <td>{{orderRecord.curSaleOrderRecordCode}}</td>
                <td align="right">创建日期：</td>
                <td>{{formatDateTimeString(orderRecord.curSaleOrderRecordCreateAt)}}</td>
            </tr>
            <tr>
                <td align="right">总件数：</td>
                <td>{{orderRecord.curSaleOrderRecordTotalPieces}}</td>
                <td align="right">总体积：</td>
                <td>{{orderRecord.curSaleOrderRecordTotalVolumn}} 立方米</td>
            </tr>
            <tr>
                <td align="right">总纸箱费：</td>
                <td>￥{{orderRecord.curSaleOrderRecordTotalPackageFee}}</td>
                <td align="right">配送站收取运费：</td>
                <td>￥{{orderRecord.curSaleOrderRecordStationDeliveryFee}}</td>
            </tr>
            <tr>
                <td align="right">本定单金额：</td>
                <td>￥{{orderRecord.curSaleOrderRecordTotalOrderCost}}</td>
                <td align="right">合计金额：</td>
                <td>￥{{orderRecord.curSaleOrderRecordTotalOrderCost + orderRecord.curSaleOrderRecordStationDeliveryFee}}</td>
            </tr>
            <tr>
                <td align="right">给卖家留言：</td>
                <td>{{orderRecord.curSaleOrderRecordRemark}}</td>
                <td align="right">配送方式：</td>
                <td>{{orderRecord.deliveryAddressType}}</td>
            </tr>
            <tr>
                <td align="right">是否要打包：</td>
                <td>{{orderRecord.packageType}}</td>
                <td align="right">收货地址：</td>
                <td>{{orderRecord.province + orderRecord.city + orderRecord.dist + orderRecord.deliveryAddressFull + orderRecord.deliveryAddressContacts}}</td>
            </tr>
            <tr>
                <td align="right">定单状态：</td>
                <td>{{orderRecord.orderStatus}}</td>
                <td align="right">配送站：</td>
                <td>{{station}}</td>
            </tr>
            <tr>
                <td align="right">客户经理：</td>
                <td>{{customerManager}}</td>
            </tr>
        </table>
		</div>
		
        <div class="dataTable">
            <b-table id="orderDetail-table"
                :fields="orderDetail.fields"
                :items="orderDetail.items"
                small
                bordered
                hover
                :busy="orderDetail.isTableBusy"
                caption-top>
                <template v-slot:cell(snNum)="row">
                    <div v-if="row.item.snNum !== -1">周期:{{row.item.curSaleOrderDetailStoreSalePeriod}}天,批次:{{row.item.curSaleOrderDetailStoreBatchCode}}</div>
                </template>
                <template slot="table-caption"><span style="font-weight: bold;">定单详细信息:{{orderRecord.curSaleorderRecordCode}}</span>
                    <div style="margin-left:20px;float:right;font-size:14px;">
                        <a href="#"
                            v-on:click="showAddressModel()">修改收货地址</a>
                    </div>
                </template>

                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>
            </b-table>
        </div>
        <div class="dataTable">
            <b-table id="deliveryTable"
                :fields="deliveryTable.fields"
                :items="deliveryTable.items"
                small
                bordered
                hover
                show-empty
                empty-text="没有找到匹配的记录"
                :busy="deliveryTable.isTableBusy"
                caption-top>
                <template v-slot:cell(distributionStationDeliveryRecordDeliveryDate)="row">
                    <div>{{formatDateTimeString(row.item.distributionStationDeliveryRecordDeliveryDate)}}</div>
                </template>
                <template slot="table-caption"><span style="font-weight: bold;">配送信息:</span></template>
                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>
                <template v-slot:cell(distributionStationDeliveryDetailIsReceive)="row">
                    <span>{{row.item.distributionStationDeliveryDetailIsReceive === 1 ?'已收货':'配送中'}}</span>
                </template>
                <template v-slot:cell(distributionStationDeliveryDetailIsComplain)="row">
                    <span>{{row.item.distributionStationDeliveryDetailIsComplain === 1 ?'已投诉':'未投诉'}}</span>
                </template>
                <template v-slot:cell(action)="row">
                    <span v-if="row.item.distributionStationDeliveryDetailIsComplain === 0">
                        <a href="#"
                            v-on:click="onComplain(row)">申请售后</a>
                    </span>
                    <span v-if="row.item.distributionStationDeliveryDetailIsComplain === 1">
                        <a href="#"
                            v-on:click="onComplain(row)">查看售后</a>
                    </span>
                </template>
            </b-table>
        </div>
        <ComplainModal ref="complainModal" />
        <AddressModal ref="addressModal" />
		
		
    </div>
</template>

<script>
import api from '@/api/api';
import { formatDateTimeString, numberToFixed } from '@/libs/utils';
import ComplainModal from './complain';
import AddressModal from './address';
import search from '@/libs/search';
import "@/style/global.css";
export default {
    name: 'OrderDetail',
    components: {
        ComplainModal,
        AddressModal
    },
    data() {
        return {
            orderDetail: {
                fields: [
                    { key: 'curSaleOrderDetailProductCode', label: '编码' },
                    { key: 'curSaleOrderDetailProductName', label: '品种' },
                    { key: 'curSaleOrderDetailProductUnit', label: '单位' },
                    { key: 'snNum', label: '批次' },
                    { key: 'curSaleOrderDetailProductDisplayPrice', label: '单价' },
                    { key: 'curSaleOrderDetailOrderQuantity', label: '数量' },
                    { key: 'curSaleOrderDetailTotalDisplayMoney', label: '金额' },
                    { key: 'curSaleOrderDetailPieces', label: '件数' },
                    // { key: 'curSaleOrderDetailPackagePrice', label: '纸箱单价' },
                    // { key: 'curSaleOrderDetailPackageTotalMoney', label: '纸箱费' },
                    { key: 'curSaleOrderDetailPackageVolume', label: '纸箱体积' },
                    { key: 'curSaleOrderDetailPackageTotalVolume', label: '总体积' }
                ],
                items: [],
                isTableBusy: false
            },
            orderRecord: {
                curSaleOrderRecordTotalOrderCost: 0,
                curSaleOrderRecordStationDeliveryFee: 0
            },
            station: '',
            customerManager: '',
            deliveryTable: {
                fields: [
                    { key: 'distributionStationDeliveryRecordCode', label: '配送单号' },
                    { key: 'distributionStationName', label: '配送站' },
                    { key: 'productName', label: '商品名称' },
                    { key: 'productCode', label: '商品编号' },
                    { key: 'unitName', label: '单位' },
                    { key: 'curSaleOrderDetailProductDisplayPrice', label: '单价' },
                    { key: 'distributionStationDeliveryQuantity', label: '数量' },
                    { key: 'deliveryProductCost', label: '金额' },
                    { key: 'distributionStationDeliveryRecordDeliveryDate', label: '配送时间' },
                    { key: 'distributionStationDeliveryDetailIsReceive', label: '物流状态' },
                    { key: "action", label: "操作" }
                ],
                items: [],
                isTableBusy: false
            }
        };
    },
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: "MemberLogin"
            });
            return;
        }
        this.getOrderDetailInfo();
        this.getOrderDeliveryDetail();
    },
    methods: {
        formatDateTimeString,
        numberToFixed,
        onComplain(row) {
            this.$refs.complainModal.showModal(row.item);
        },
        showAddressModel() {
            this.$refs.addressModal.showModal(this.orderRecord.curSaleOrderRecordUuid, '现售');
        },
        getOrderDetailInfo() {
            this.orderDetail.isTableBusy = true;
            api.webCurrentSaleGetOrderDetail({ curSaleOrderRecordUuid: this.$route.query.curSaleOrderRecordUuid }).then(res => {
                this.orderDetail.isTableBusy = false;
                if (res.code === 0) {
                    this.orderDetail.items = res.data.orderDetail;
                    this.orderRecord = res.data.orderRecord;
                    this.station = res.data.distributionStation.distributionStationName;
                    this.customerManager = res.data.customerManager.userCustomerManagerName;

                    let totalQuantity = 0;
                    let totalValue = 0;
                    this.orderDetail.items.forEach(e => {
                        totalQuantity += e.curSaleOrderDetailOrderQuantity;
                        totalValue += e.curSaleOrderDetailTotalDisplayMoney;
                    });
                    this.orderDetail.items.push({
                        curSaleOrderDetailOrderQuantity: totalQuantity,
                        curSaleOrderDetailTotalDisplayMoney: this.numberToFixed(totalValue, 2),
                        curSaleOrderDetailProductDisplayPrice: '合计',
                        snNum: -1
                    });
                }
            });
        },
        getOrderDeliveryDetail() {
            this.deliveryTable.isTableBusy = true;
            api.webGetCurSaleOrderDeliveryList({ curSaleOrderRecordUuid: this.$route.query.curSaleOrderRecordUuid }).then(res => {
                this.deliveryTable.isTableBusy = false;
                if (res.code === 0) {
                    this.deliveryTable.items = res.data.deliveryDetails;
                }
            });
        }
    }
};
</script>

<style>
.orderKey {
    text-align: right;
    font-size: 14px;
    font-weight: bold;
}

.orderValue {
    font-size: 14px;
}

/* .top-line{border-top:1px solid #dbdbdb;} */
/* 信息 */
.info-wrap{width:980px;border:1px solid #efefef;margin:20px auto;background-color:#fafafa;padding:15px 0px;}
.info-wrap .order-info td{padding:5px 0px;}
.info-wrap .order-info td:nth-child(even){color:#a16e02;}



/* 表格 */
.dataTable{margin-top:20px;}
.dataTable th{background-color:#efefef;height:32px;line-height:32px;}
.table.b-table.b-table-caption-top > caption{color:#333;}

.table thead th{vertical-align: bottom; border-bottom: 2px solid #dbdbdb;}
.table-bordered td, .table-bordered th {border: 1px solid #dbdbdb;}
.table-sm td, .table-sm th{padding:10px 5px;}

/* 页码 */
.page-link{color:#757575 !important;}
 .page-link:hover{color: #00b151 !important;}
 .page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
 .pagination-sm .page-link{
 	padding: 5px 12px !important;
 	margin-top: 40px;
 	}	
 .page-link:focus{box-shadow: none !important;}	



</style>



// WEBPACK FOOTER //
// src/view/member/order-detail.vue